import { render, staticRenderFns } from "./pindaanPengesahanList-hibah.vue?vue&type=template&id=09f68dd7&"
import script from "./pindaanPengesahanList-hibah.vue?vue&type=script&lang=js&"
export * from "./pindaanPengesahanList-hibah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports